import { Directive, ElementRef, Renderer2, AfterViewInit } from '@angular/core';

@Directive({
  selector: '[appReplaceOembed]'
})
export class ReplaceOembedDirective implements AfterViewInit {
  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngAfterViewInit(): void {
    const oembedTags = this.el.nativeElement.querySelectorAll('oembed');
    oembedTags.forEach((oembed: HTMLUnknownElement) => {
      const url = oembed.getAttribute('url');
      if (url) {
        // Check if the URL belongs to a site that blocks iframe embedding
        if (this.isIframeBlocked(url)) {
          // Create a fallback link
          const link = this.renderer.createElement('a');
          this.renderer.setAttribute(link, 'href', url);
          this.renderer.setAttribute(link, 'target', '_blank');
          this.renderer.setProperty(link, 'innerText', 'View this content');
          // Replace <oembed> with the fallback link
          const parent = oembed.parentNode;
          if (parent) {
            this.renderer.removeChild(parent, oembed);
            this.renderer.appendChild(parent, link);
          }
        } else {
          // Create an iframe
          const iframe = this.renderer.createElement('iframe');
          this.renderer.setAttribute(iframe, 'src', url);
          this.renderer.setAttribute(iframe, 'width', '100%');
          this.renderer.setAttribute(iframe, 'height', '315');
          this.renderer.setAttribute(iframe, 'frameborder', '0');
          this.renderer.setAttribute(iframe, 'allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
          this.renderer.setAttribute(iframe, 'allowfullscreen', 'true');
          // Replace <oembed> with the <iframe>
          const parent = oembed.parentNode;
          if (parent) {
            this.renderer.removeChild(parent, oembed);
            this.renderer.appendChild(parent, iframe);
          }
        }
      }
    });
  }

  private isIframeBlocked(url: string): boolean {
    // Add logic to detect iframe-blocked URLs (e.g., Facebook)
    const blockedHosts = ['facebook.com', 'maps.google.com'];
    return blockedHosts.some(host => url.includes(host));
  }
}
